export enum WifiAmenitiesEnum {
   WIFI = 'Wi-Fi',
   WIFI_COMPLIMENTARY = 'Wi-Fi Complimentary',
   WIFI_EXTRA_COST = 'Wi-Fi May Be Available at an Extra Cost',
   SATELLITE_BASED_WIFI = 'Satellite-Based Wi-Fi',
   EUROPE = "Europe",
   CONTIGUOUS_US = "Contiguous US",
   WORLDWIDE = "Worldwide",
   STARLINK_WIFI = 'Starlink Wi-Fi',
   STARLINK_WIFI_AT_AN_EXTRA_COST = 'Starlink Wi-Fi at an extra cost',
   STARLINK_WIFI_COMPLIMENTARY = 'Starlink Wi-Fi complimentary',
}
